import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Footer } from '../shared/Footer';

import '../../styles/style.scss';

// import TokenService from "../../services/auth/generateToken.service";
import AuthService from "../../services/auth/auth.service";


import { actionErrorConnection } from "../../constants/component/actionErrorConnection";

export const ConfirmRegisterScreen = (props) => {

    const an8Confirm = props.match.params.id;

    const [isLoadingToken, setIsLoadingToken] = useState(false);
    const [isLoadingRegister, setIsLoadingRegister] = useState(false);
    const [isErrorRegister, setIsErrorRegister] = useState(false);

    useEffect(() => {
    // Servicio para recuperar token de inicio
    // TokenService.getInitToken().then(
    //     () => {
            setIsLoadingToken(false);
            setIsLoadingRegister(true);
            // Servicio para realizar confirmacion de cliente
            AuthService.confirmRegister(an8Confirm)
            .then(()=>{
                setIsLoadingRegister(false);
                setIsErrorRegister(false);
            })
            .catch((error=>{
                setIsLoadingRegister(false);
                setIsErrorRegister(true);
                actionErrorConnection(error);   
            }));
        // },
        // (error) => {
        //     setIsLoadingToken(true);
        //     actionErrorConnection(error, 'Error al establecer sesión. Intente más tarde.');   
        // }
        // );
    },[an8Confirm]);

    if ( isLoadingToken ) {
        return (
            <div className="w-100 vh-100 container">
                <div className="row h-100">
                    <div className="col align-self-center d-flex justify-content-center">
                        <span className="custom-icon-loading">
                            <i className="fas fa-spinner fa-spin"></i>
                        </span>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
        <div className="container">
            <div className="row justify-content-center ">
                <div className="col-md-4 col-sm-9">
                    <div className="login pt-3">
                        <img src="/images/logo.jpg" alt="logo" className="w-75"/>
                        <h1 className="text-center pt-1 pb-3 text-title">Confirmación</h1>
                        <div className="container h-100">
                            <div className="row">
                                <div className="col-12 d-flex justify-content-center mb-3">
                                    {
                                        isLoadingRegister &&
                                        <span className="custom-icon-loading"><i className="fas fa-spinner fa-spin"></i></span>
                                    }
                                    {
                                        (!isLoadingRegister && !isErrorRegister) &&
                                        <span>Gracias por confirmar su registro.</span>
                                    }
                                    {
                                        (!isLoadingRegister && isErrorRegister) &&
                                        <div>
                                            <div className="custom-error-text">
                                                <span className="d-block">Error al realizar la confirmación.</span>
                                                <span className="d-flex justify-content-center">Intente mas tarde.</span>
                                            </div>
                                        </div>
                                    }
                                    
                                </div>
                                <div className="col-12 mb-1">
                                    <Link className="btn btn-link custom-link-color" to="/auth/">
                                        Ir a Inicio de sesión
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
            
                </div>
            </div>
        </div>
            
        <Footer />
        </>
    )
}

ConfirmRegisterScreen.propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string
      })
    })
  }